
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>G H Raisoni Memorial Vidarbha Level Badminton Tournament</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-12">
               <p>Hats off to all the amazing players at the Yonex-Sunrise G H Raisoni Memorial Vidarbha Level Badminton Tournament! Your passion is unmatched. Congratulations to all!</p>
            </div>


        </div>

        <div class="col-lg-12">
            <div class="gall-ery">
                <div class="row">
                    <div class="col-md-8">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a> -->
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-4.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-4.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-1.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-1.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-2.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-2.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-3.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-3.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-5.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-5.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-5.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-6.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-6.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-6.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-7.avif"
                            data-src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-7.avif"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://sgrkfcdn.s3.ap-south-1.amazonaws.com/sgrkf/galley/events/badminton-vidarbha-7.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>

    </div>

</section>

